import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { OfflineGuard } from './components/OfflineGuard'
import { AuthProvider } from './context/AuthContext'
import './styles.css'
import './loyalty-fix.css'
import './mobile-guest.css'
import './notification-ui.css'
import './cashier-layout.css'
import './sidebar-scroll.css'
import './stock-availability.css'
import './admin-ui-polish.css'
import './table-cards-fix.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <OfflineGuard>
        <AuthProvider><App/></AuthProvider>
      </OfflineGuard>
    </BrowserRouter>
  </StrictMode>
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'))
}
